import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import { CurrencyInput } from 'vue-currency-input';
let NumericInput = class NumericInput extends Vue {
    get maxValue() {
        if (this.percentage) {
            const maxValue = 100;
            return maxValue;
        }
        return null;
    }
    get precision() {
        let precision = 2;
        if (this.percentage) {
            precision = 0;
        }
        return precision;
    }
};
__decorate([
    Prop({ type: Number, default: 0 })
], NumericInput.prototype, "value", void 0);
__decorate([
    Prop({ type: String })
], NumericInput.prototype, "dataCy", void 0);
__decorate([
    Prop({ type: String, default: '' })
], NumericInput.prototype, "label", void 0);
__decorate([
    Prop({ type: String, default: '' })
], NumericInput.prototype, "placeholder", void 0);
__decorate([
    Prop({ type: String, default: '' })
], NumericInput.prototype, "color", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], NumericInput.prototype, "disabled", void 0);
__decorate([
    Prop({ type: String, default: '' })
], NumericInput.prototype, "hint", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], NumericInput.prototype, "persistentHint", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], NumericInput.prototype, "percentage", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], NumericInput.prototype, "errorMessages", void 0);
NumericInput = __decorate([
    Component({
        components: {
            CurrencyInput,
        },
    })
], NumericInput);
export default NumericInput;
